/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archive_JobInputs */

const en_archive_job = /** @type {(inputs: Archive_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive Job`)
};

const fr_archive_job = /** @type {(inputs: Archive_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiver la tâche`)
};

const de_archive_job = /** @type {(inputs: Archive_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivierungsjob`)
};

const it_archive_job = /** @type {(inputs: Archive_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivio lavoro`)
};

const ru_archive_job = /** @type {(inputs: Archive_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Архив заданий`)
};

const es_archive_job = /** @type {(inputs: Archive_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo de archivo`)
};

const zh_cn2_archive_job = /** @type {(inputs: Archive_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存档作业`)
};

const ja_archive_job = /** @type {(inputs: Archive_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブジョブ`)
};

const hi_archive_job = /** @type {(inputs: Archive_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आर्काइव जॉब`)
};

const pt_pt2_archive_job = /** @type {(inputs: Archive_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho de Arquivo`)
};

/**
* | output |
* | --- |
* | "Archive Job" |
*
* @param {Archive_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const archive_job = /** @type {((inputs?: Archive_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archive_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_archive_job(inputs)
	if (locale === "de") return de_archive_job(inputs)
	if (locale === "it") return it_archive_job(inputs)
	if (locale === "ru") return ru_archive_job(inputs)
	if (locale === "es") return es_archive_job(inputs)
	if (locale === "zh-CN") return zh_cn2_archive_job(inputs)
	if (locale === "ja") return ja_archive_job(inputs)
	if (locale === "hi") return hi_archive_job(inputs)
	if (locale === "pt-PT") return pt_pt2_archive_job(inputs)
	return en_archive_job(inputs)
});